(function () {
  if (window.__vanemarLocalizationReady) return;
  window.__vanemarLocalizationReady = true;

  var roots = document.querySelectorAll('[data-loc-selector]');
  if (!roots.length) return;

  var docLang = document.documentElement.lang || 'en';

  function fold(text) {
    return (text || '').toLocaleLowerCase(docLang).trim();
  }

  function filterCountries(group, query) {
    var items = group.querySelectorAll('[data-loc-country-item]');
    var empty = group.querySelector('[data-loc-empty]');
    var q = fold(query);
    var visible = 0;

    items.forEach(function (item) {
      var haystack = item.getAttribute('data-loc-search-text') || '';
      var hit = q === '' || haystack.indexOf(q) !== -1;
      item.style.display = hit ? '' : 'none';
      if (hit) visible++;
    });
    if (empty) empty.hidden = visible > 0;
  }

  function resetSearch(group) {
    var search = group.querySelector('[data-loc-search]');
    if (!search) return;
    search.value = '';
    filterCountries(group, '');
  }

  function closeAll(except) {
    roots.forEach(function (root) {
      root.querySelectorAll('[data-loc-group]').forEach(function (group) {
        if (group === except) return;
        var panel = group.querySelector('[data-loc-panel]');
        var trigger = group.querySelector('[data-loc-trigger]');
        if (panel && !panel.hidden) {
          panel.hidden = true;
          trigger.setAttribute('aria-expanded', 'false');
          resetSearch(group);
        }
      });
    });
  }

  function createCheckIcon() {
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    var path = document.createElementNS(ns, 'path');
    svg.setAttribute('class', 'loc-sel__check');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '2.5');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    path.setAttribute('d', 'M5 13l4 4L19 7');
    svg.appendChild(path);
    return svg;
  }

  function createCountryItem(option) {
    var active = option.getAttribute('data-active') === 'true';
    var li = document.createElement('li');
    var button = document.createElement('button');
    var name = document.createElement('span');
    var meta = document.createElement('span');

    li.setAttribute('role', 'presentation');
    li.setAttribute('data-loc-country-item', '');
    button.type = 'button';
    button.className = 'loc-sel__option' + (active ? ' is-active' : '');
    button.setAttribute('data-loc-pick', 'country');
    button.setAttribute('data-value', option.value);
    button.setAttribute('role', 'option');
    button.setAttribute('aria-selected', active ? 'true' : 'false');
    name.textContent = option.textContent;
    meta.className = 'loc-sel__meta';
    meta.textContent = option.getAttribute('data-meta') || '';
    button.appendChild(name);
    button.appendChild(meta);
    button.appendChild(createCheckIcon());
    li.appendChild(button);
    li.setAttribute('data-loc-search-text', fold(button.textContent) + ' ' + fold(option.value));
    return li;
  }

  function hydrateCountries(group) {
    var list = group.querySelector('[data-loc-country-list-deferred]');
    if (!list || list.children.length) return;
    var source = document.querySelector('[data-loc-country-source]');
    if (!source) return;
    var fragment = document.createDocumentFragment();
    Array.prototype.forEach.call(source.options, function (option) {
      fragment.appendChild(createCountryItem(option));
    });
    list.appendChild(fragment);
  }

  roots.forEach(function (root) {
    var form = root.querySelector('form');
    if (!form) return;

    root.querySelectorAll('[data-loc-group]').forEach(function (group) {
      var trigger = group.querySelector('[data-loc-trigger]');
      var panel = group.querySelector('[data-loc-panel]');
      var search = group.querySelector('[data-loc-search]');
      if (!trigger || !panel) return;

      trigger.addEventListener('click', function (event) {
        event.stopPropagation();
        var isOpen = !panel.hidden;
        closeAll(null);
        if (!isOpen) {
          hydrateCountries(group);
          panel.hidden = false;
          trigger.setAttribute('aria-expanded', 'true');
          if (search && window.matchMedia('(hover: hover) and (pointer: fine)').matches) search.focus();
        }
      });

      panel.addEventListener('click', function (event) {
        event.stopPropagation();
        var option = event.target.closest('[data-loc-pick]');
        if (!option) return;
        var kind = option.getAttribute('data-loc-pick');
        var value = option.getAttribute('data-value');
        var input = kind === 'locale'
          ? form.querySelector('[data-loc-locale]')
          : form.querySelector('[data-loc-country]');
        if (!input || input.value === value) {
          closeAll(null);
          return;
        }
        input.value = value;
        form.submit();
      });

      if (search) {
        search.addEventListener('input', function () {
          filterCountries(group, search.value);
        });
      }
    });
  });

  document.addEventListener('click', function () { closeAll(null); });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var openPanel = document.querySelector('[data-loc-group] [data-loc-panel]:not([hidden])');
    closeAll(null);
    if (openPanel) {
      var trigger = openPanel.closest('[data-loc-group]').querySelector('[data-loc-trigger]');
      if (trigger) trigger.focus();
    }
  });

  /* The locale in the URL is authoritative. Do not redirect first-time
     visitors from /tr or /fr based on navigator.language: crawlers render in
     their own browser locale and could otherwise replace the localized page
     with the English storefront. Manual language selection above remains the
     only way this script submits Shopify's localization form. */
})();
